import { useEffect } from "react";
import Button from "@material-ui/core/Button";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  LoadCanvasTemplateNoReload,
  validateCaptcha,
} from "react-simple-captcha";
import { CircularProgress } from "@material-ui/core";
import axios from "axios";
import { NotificationManager } from "react-notifications";
import { path } from "../../../order_managment/constants/apiPath";
import { baseUrlRate } from "../../../config";

const CaptchaTest = ({
  setAlertText,
  loading,
  setOpenalert,
  setSeverity,
  setLoading,
  number,
  email,
  company,
  name,
  token,
  setNumber,
  setEmail,
  setName,
  setCompany,
}) => {
  useEffect(() => {
    loadCaptchaEnginge(6);
  }, []);

  const rmsSignUp = () => {
    console.log("RMS Signup Clicked");
    const fullName = name.trim();
    const emailAddress = email.trim();
    const companyName = company.trim();

    const header = {
      Authorization: `Bearer ${token}`,
      // UserName: "nezih@mtsnyc.com",
      // UserSecret: "Soft@1234",
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
      // originPostalCode: "78744",
      // destinationPostalCode: "44130",
      // ratedClass: "60",
      // weight: "140",
    };

    setLoading(true);
    const URL = `${baseUrlRate}${path.GUEST_ACCESS_REQUEST}`;
    const params = {
      // user_id: email,
      fullName: name,
      email: email,
      // password: "",
      companyName: company,
      // country_code: "",
      // ActionName: "Add",
      mobileNumber: number,
    };
    // console.log(fullName);
    axios
      .post(URL, params, {
        headers: header,
      })
      .then((res) => {
        setLoading(false);
        console.log("RMS SIGN UP:", res);
        if (!loading) {
          NotificationManager.success(
            "Guest Access Request Successfully forwarded via eMail.",
            "",
            3000
          );
        }
        setCompany("");
        setName("");
        setEmail("");
        setNumber(undefined);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        // setOpenalert(true);
        // setSeverity("error");
        NotificationManager.error(
          "Can't Proceed! All feilds are mandatory.",
          "",
          3000
        );
        // setAlertText("Can't Proceed! All feilds are mandatory.");
      });
  };

  const doSubmit = () => {
    let user_captcha = document.getElementById("user_captcha_input").value;

    if (validateCaptcha(user_captcha) === true) {
      //   alert("Captcha Matched");
      rmsSignUp();
      loadCaptchaEnginge(6);
      document.getElementById("user_captcha_input").value = "";
    } else {
      //   alert("Captcha Does Not Match");
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Captcha Does Not Match");
      document.getElementById("user_captcha_input").value = "";
    }
  };

  return (
    <div>
      <div className="container">
        <div className="form-group">
          <div
            className="col mt-3 d-flex justify-content-center"
            // style={{ fontSize: "16px" }}
          >
            <LoadCanvasTemplate />
          </div>
          <div className="col mt-3">
            <div>
              <input
                placeholder="Enter Captcha "
                id="user_captcha_input"
                name="user_captcha_input"
                type="text"
              />
            </div>
          </div>
          <div className="col mt-3">
            <div className="loginButton my-3">
              {/* <button className="btn btn-primary">Submit</button> */}
              <Button variant="contained" onClick={doSubmit}>
                {loading ? <CircularProgress size="1.5rem" /> : "Sign Up"}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaptchaTest;
